import { Avatar } from 'primereact/avatar';
import { useTEAME223SpeculativeAvatarData } from './useTEAME223SpeculativeAvatarData';

interface Props {
  fallback?: string;
  className?: string;
}

// Only mount this component when the TEAME-223 flag is enabled.
// Relay hooks inside useTEAME223SpeculativeAvatarData only run when this component is rendered.
export function HeaderAvatarImage({ fallback, className }: Props) {
  const { avatarDataUrl } = useTEAME223SpeculativeAvatarData();
  return <Avatar image={avatarDataUrl ?? fallback} className={className} shape="circle" />;
}
